import store from '@/store'
import { clearPatientUploadResultsDownload } from '@/patient-upload-export'

export function touchActivity() {
  // idle-vue listens on document; window-only events do not reset its timer.
  document.dispatchEvent(
    new MouseEvent('mousemove', { bubbles: true, cancelable: true })
  )
  store.commit('idleVue/IDLE_CHANGED', false)
}

export function beginPatientUpload() {
  touchActivity()
  clearPatientUploadResultsDownload()
  store.commit('app/beginPatientUpload')
}

export function trackPatientUpload(
  uploadId: string,
  total: number,
  staging = false
) {
  touchActivity()
  store.commit('app/trackPatientUpload', { uploadId, total, staging })
}

export function releasePatientUpload() {
  touchActivity()
  store.commit('app/finishPatientUpload')
}
